// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
      //suggestionMode: 'test',
      //suggestionPosition: 'left'
  },
};
(function() {
	BoostPFS.inject(this);
	// Reszie Suggestion Box
	SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
		if (!suggestionElement) suggestionElement = this.$uiMenuElement;   // Add this line
		if (!searchElement) searchElement = this.$element;  // Add this line
		if (!searchBoxId) searchBoxId = this.id; // Add this line
		// Set Width for Suggestion box when opening
		// By default, the width of Suggestion box is equal to the Search box
		var width = searchElement.outerWidth();
		suggestionElement.outerWidth(width);
		if (jQ('.fancybox-overlay').length > 0) {
			jQ(suggestionElement).css({
				'position': 'fixed',
				'overflow-y': 'scroll',
				'height': '100px'
			});
		}
	};

	BoostPFS.prototype.afterBuildSearchBox = function(id) {
		if (jQ(id).closest('form').length > 0){
			var submitButton = jQ(id).closest('form').find('[type="submit"]');
			if (submitButton && submitButton.length > 0){
				submitButton.each(function(index, button){
				button.setAttribute('name', 'bc-search-button');                
				});
			}
		}
	};

	SearchInput.prototype._onSubmit = function(event, redirect) {
		if (!redirect) {
			// Stop all default submit events
			event.stopImmediatePropagation();
			//Moved preventDefault to only when redirect is applied since it causes conflicts with submit event of the theme
			event.stopPropagation();
			// Fix case can not get current value from input
			Globals.currentTerm = this.$element.val();
			if (!Globals.currentTerm && event && event.target) {
			Globals.searchTerm = event.target.value;
			}
			var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
			/**
			 * if API returned results or the suggestionCache has the search term, submit search
			 * else: add the data-search-submit attribute to the search input box, wait for the api returns the result, then remove this attribute in the checkForSearchRedirect function
			 * @type {Boolean}
			 */
			var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(Globals.currentTerm.toString().trim());
			// If the API returned results, either redirect or perform submit
			if (isApiReturnedResult) {
			if (redirectUrl) {
				event.preventDefault();
				window.location.href = redirectUrl;
			} else {
				this.$searchForm.trigger('submit', [true]);
			}
			} else {
			event.preventDefault();
			// If the API hasn't returned results, set data-search-submit on the search input and wait
			this.$element.data('search-submit', true);
			}
		}
	}
    
    // Added code for Lockmith integration

    InstantSearchApi.afterCallAsync = function(result, callbackInstantSearchApi) {
        /* Call 3rd party api */
        if (typeof window.Locksmith === 'object') {
        var URLs = []
        var URLsCollection = []
        var totalUrls = []
        var grantedAccess = []
        var grantedAccessCollection = []
        //Create an array of products URLs
        for(var i = 0; i < result.products.length; i ++){
            URLs.push('/products/' + result.products[i].handle);
        }
        for(var i = 0; i < result.collections.length; i ++){
            URLsCollection.push('/collections/' + result.collections[i].handle);
        }
        totalUrls = URLs.concat(URLsCollection)
        jQ.ajax({
            method: 'GET',
            url: '/apps/locksmith/api/resources',
            data: { urls: totalUrls,},
            timeout: 1500,
        async: false,
            success: function(response) {
                var resources = JSON.parse(response);
                for(var i = 0; i < URLs.length; i ++){
                    //Checks that the response exists
                    if(resources[URLs[i]]){
                    //Checks that the access of the product has been granted
                    if(resources[URLs[i]].access_granted || resources[URLs[i]].manual_lock){
                        //If the product is accesible add it to the array of the products
                        grantedAccess.push(result.products[i])
                    }
                    }
                }
                //Change array of products
                result.products = grantedAccess;
                //Same for collections
                for(var i = 0; i < URLsCollection.length; i ++){
                    //Checks that the response exists
                    if(resources[URLsCollection[i]]){
                    //Checks that the access of the product has been granted
                    if(resources[URLsCollection[i]].access_granted || resources[URLsCollection[i]].manual_lock){
                        //If the product is accesible add it to the array of the products
                        grantedAccessCollection.push(result.collections[i])
                    }
                    }
                }
                //Change array of collections
                result.collections = grantedAccessCollection;
                /* Build everything after getting instant search data */
                callbackInstantSearchApi(result);
            },
            error: function() {
                /* Build everything after getting instant search data */
                callbackInstantSearchApi(result);
            },
        });
        } else {
            callbackInstantSearchApi(result);
        }
    }

})();

